













import {Component, Mixins, Prop} from 'vue-property-decorator'
import Assets from '@/mixins/Assets'

type Name = 'loudspeaker' | 'construction' | 'exclamation' | 'light-bulb' | 'lock' | 'no-entry' | 'party-popper' | 'sparkles' | 'thumbs-up' | 'ic_notice'

@Component
export default class NoticeImg extends Mixins(Assets) {
  @Prop({default: 'ic_notice', type: String}) name: Name
  @Prop({default: 30, type: Number}) width: number

  getName = (name) => {
    if(name === 'loudspeaker') {
      return 'ic_notice'
    }
    return name
  }

}
